import '../style/icon-button-B5d2XzKS.css'
import { defineComponent as d, computed as t, withDirectives as m, openBlock as b, createElementBlock as h, mergeProps as f, renderSlot as S, createVNode as v, unref as n, normalizeProps as z, guardReactiveProps as g } from "vue";
import { pxlize as r } from "x-utils";
import y from "./icon.js";
import { SIZE_MAP as P } from "./constant/icon-button.js";
import { PLAIN_RIPPLE_SETTING as _ } from "./constant/ripple.js";
import B from "./directives/ripple.js";
import { useOverrides as k } from "./hooks/useOverrides.js";
const w = ["disabled", "aria-label"], O = /* @__PURE__ */ d({
  name: "e-icon-button",
  __name: "icon-button",
  props: {
    disabled: { type: Boolean },
    icon: {},
    svg: {},
    size: { default: "md" },
    iconSize: {},
    buttonSize: {},
    hideSkeleton: { type: Boolean },
    height: {},
    width: {},
    circle: { type: Boolean },
    color: {},
    ripple: { type: [Boolean, Object], default: () => _ },
    hoverScale: { type: Boolean },
    overrides: {}
  },
  setup(s) {
    const o = s, i = P[o.size], { overridesStyle: l } = k("icon-button", o.overrides), c = t(() => {
      const e = o.buttonSize || i?.buttonSize;
      return {
        width: o.width ?? r(e),
        height: o.height ?? r(e)
      };
    }), a = t(() => ({
      ...c.value,
      ...l.value,
      color: o.color
    })), u = t(() => {
      const e = ["e-icon-button"];
      return o.circle && e.push("e-icon-button--circle"), o.hoverScale && e.push("e-icon-button--hover-scale"), e;
    }), p = t(() => {
      const e = o.iconSize || i?.iconSize;
      return {
        icon: o.icon,
        svg: o.svg,
        size: e,
        hideSkeleton: o.hideSkeleton
      };
    });
    return (e, E) => m((b(), h("button", f(e.$attrs, {
      tabindex: "0",
      disabled: e.disabled,
      "aria-label": e.icon,
      style: a.value,
      class: u.value
    }), [
      S(e.$slots, "default"),
      v(n(y), z(g(p.value)), null, 16)
    ], 16, w)), [
      [n(B), e.ripple]
    ]);
  }
});
export {
  O as default
};
//# sourceMappingURL=icon-button.js.map
